import { render, staticRenderFns } from "./ListBillsFille.vue?vue&type=template&id=67225a1a&scoped=true"
import script from "./ListBillsFille.vue?vue&type=script&lang=js"
export * from "./ListBillsFille.vue?vue&type=script&lang=js"
import style0 from "./ListBillsFille.vue?vue&type=style&index=0&id=67225a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67225a1a",
  null
  
)

export default component.exports